import React from "react";
import styles from "../NavigationMenu.module.scss";
import titleStyles from "./NavigationChildItem.module.scss";
import {Link} from "react-router-dom";
import Badge from "@/components/Global/Badge/Badge";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamation} from "@fortawesome/pro-solid-svg-icons/faExclamation";
import {faChevronRight} from "@fortawesome/pro-regular-svg-icons/faChevronRight";

export default function NavigationChildItem({path, title, displayBadge}) {
  return (
    <li className={`list-group-item ${titleStyles.border} p-0 rounded-0`} data-children="true">
      <Link className={`d-flex align-items-center px-0 py-1 ${styles.navItem}`} to={path}>
        <div className={`d-flex flex-column flex-grow-1 px-3 ${titleStyles.titleStyle}`}>{title}</div>
        <RenderIf isTrue={displayBadge}>
          <Badge variant="danger" size="md" className={`rounded-circle p-0 ${styles.badge}`} pillShape={false}>
            <FontAwesomeIcon icon={faExclamation} size="xs" />
          </Badge>
        </RenderIf>
        <div className={styles.navItemChevron}>
          <FontAwesomeIcon icon={faChevronRight} size="xl" />
        </div>
      </Link>
    </li>
  );
}
